<template>
	<div class="container">
		<div class="content">
			<h2>{{ $t('cookies.title') }}</h2>
			<p>
				{{ $t('cookies.text1') }}
			</p>
			<p>
				{{ $t('cookies.text2') }}
			</p>
			<p>{{ $t('cookies.text3') }}</p>
			<p>
				{{ $t('cookies.text4') }}
			</p>

			<p>{{ $t('cookies.text5') }}</p>
			<ul class="link_list">
				<li>
					<a
						href="https://support.google.com/analytics/answer/6004245"
						target="_blank"
						>{{ $t('cookies.text6') }}</a
					>
				</li>
				<li>
					<a href="https://tools.google.com/dlpage/gaoptout" target="_blank">{{
						$t('cookies.text7')
					}}</a>
				</li>
			</ul>

			<p>
				{{ $t('cookies.text8') }}
			</p>

			<p>
				{{ $t('cookies.text9') }}
			</p>

			<p>
				{{ $t('cookies.text10') }}
			</p>

			<p>
				{{ $t('cookies.text11') }}
			</p>

			<ul class="link_list">
				<li>
					<a
						href="https://support.mozilla.org/kb/enable-and-disable-cookies-website-preferences"
						target="_blank"
						>{{ $t('cookies.text12') }}</a
					>
				</li>
				<li>
					<a
						href="https://support.google.com/chrome/answer/95647"
						target="_blank"
						>{{ $t('cookies.text13') }}</a
					>
				</li>
				<li>
					<a
						href="https://support.apple.com/guide/safari/sfri11471"
						target="_blank"
						>{{ $t('cookies.text14') }}</a
					>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Cookies',
};
</script>

<style scoped>
.container {
	background-color: #fff;
}
h2 {
	margin-bottom: 50px;
}
p {
	margin: 10px 0;
	line-height: 1.25;
}
.link_list {
	margin: 20px 0;
}
.link_list a {
	color: #0070ba;
}
.link_list li {
	position: relative;
	margin: 5px 0 5px 0;
	padding-left: 10px;
	font-size: 15px;
	font-weight: 300;
}
.link_list li:before {
	content: '\2022';
	position: absolute;
	left: 0;
	width: 10px;
	font-size: 14px;
	color: #333;
}
</style>
